import { render, staticRenderFns } from "./summary-report-review.vue?vue&type=template&id=17aa6fa3&scoped=true"
import script from "./summary-report-review.vue?vue&type=script&lang=js"
export * from "./summary-report-review.vue?vue&type=script&lang=js"
import style0 from "./summary-report-review.vue?vue&type=style&index=0&id=17aa6fa3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17aa6fa3",
  null
  
)

export default component.exports